import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

type Func = <T extends string | number>(p: T | undefined) => void;

@Injectable()
export class CrmService {
  private formGroup: FormGroup;

  get group() {
    return this.formGroup;
  }

  constructor(private readonly fb: FormBuilder) {}

  init(cb: Func) {
    this.formGroup = this.fb.group({
      header: 'Unique identifiers',
      actionButtons: this.fb.array([
        this.fb.group({
          title: 'Add CRM-ID keyspace',
          isDisabled: true,
          class: 'btn btn-primary',
          click: cb,
          actionOK: this.fb.group({
            text: 'CRM-ID keyspace setup in progress. Please wait ...',
            enabled: false,
          }),
          actionFAIL: this.fb.group({
            text:
              'CRM-ID keyspace setup takes longer than expected. It should be completed in a few minutes',
            enabled: false,
          }),
        }),
      ]),
      data: this.fb.group({
        default: this.fb.group({
          descriptions: [
            [
              'Creates CRM-ID keyspace and sets up the required permissions (realms, subscription management and type whitelisting for attribute and event types).',
              'If CRM-ID keyspace already exists on the account, this button can be used to setup whitelisting for any recently added attribute and event types.',
            ],
          ],
        }),
      }),
    });
  }

  crmKeyspaceTimeoutInProgress(inProgress: boolean | undefined) {
    const actionButtons = this.formGroup.get('actionButtons') as FormArray;
    actionButtons.controls[0].patchValue({
      isDisabled: inProgress,
      actionOK: { enabled: inProgress },
    });
  }

  crmKeyspaceTimeoutFailed(isFailed: boolean | undefined) {
    const actionButtons = this.formGroup.get('actionButtons') as FormArray;
    actionButtons.controls[0].patchValue({
      actionFAIL: { enabled: isFailed },
    });
  }
}
